import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { XnFormComponent, XnFormField, convertArrayFieldsToColumns } from '../../ui-components/xn-form/xn-form/xn-form.component';
import { IAppConfig } from '../../core/config/app-config.model';
import { APP_CONFIG } from '../../core/config/app-config.service';
import { AuthService } from '../../core/api/auth.service';
import { ApiReadHotelContactInformationRS, RegisterRQ, SaveDraftApplicationRQ } from '../../core/api/api.models';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { BtrBookingService } from '../../core/services/btr-booking.service';

interface RegisterFormData{
  firstName: string,
  lastName: string,
  phoneNumber: string,
  phoneNumberDialCode: string,
  email: string,
  logonName: string,
  password: string,
  confirmPassword: string,
}

export type LoginAction = 'Booking' | 'Sitetour';

export type GgEventAction = 'BookSiteTour' | 'BookBooking';

export type GgEventName = 'register_form' | 'register_success';

@Component({
  selector: 'app-login-form',
  standalone: false,
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.sass']
})
export class LoginFormComponent implements OnInit, OnDestroy {
  @Input() visible: boolean = false
  @Input() loginAction?: LoginAction;

  constructor(
    @Inject(APP_CONFIG) protected config: IAppConfig,
    protected auth: AuthService,
    protected confirmationService: ConfirmationService,
    private translate: TranslateService,
    private bookingService: BtrBookingService
  ){

  }

  loginFields: XnFormField[] = [{
    name: 'email',
    type: 'email',
    label: 'Email',
    placeholder: 'abc@gmail.com',
    required: true
  }, {
    name: 'password',
    type: 'password',
    label: 'Password',
    placeholder: 'Password',
    required: true
  }]

  isLoginFormSubmitted = false

  registerFields: XnFormField[] = convertArrayFieldsToColumns([{
    name: 'firstName',
    label: 'First Name',
    placeholder: 'Your name',
    required: true
  }, {
    name: 'lastName',
    label: 'Last Name',
    placeholder: 'Your surname',
    required: true
  }, {
    name: 'phoneNumber',
    label: 'Contact Number',
    placeholder: 'Your contact number',
    required: true,
    type: 'phone'
  }, {
    name: 'email',
    label: 'Email Address',
    placeholder: 'Your email address',
    required: true,
    type: 'email'
  }, /*{
    name: 'logonName',
    label: 'Username',
    placeholder: 'Username',
    required: true,
    customValidateError: (value, data) => {
      if(value && !this.validateUserName(value)) {
        return 'Username can only contain letters and numbers';
      }
      return '';
    }
  },*/ {
    name: 'password',
    type: 'password',
    label: 'Password',
    placeholder: 'Password',
    required: true
  }, {
    name: 'confirmPassword',
    label: 'Confirm Password',
    type: 'password',
    placeholder: 'Confirm Password',
    required: true,
    customValidateError: (value, data) => {
      if(data && data.password && value && data.password !== value) {
        return 'profile.error.password-must-the-same';
      }
      return '';
    },
    hidePasswordHints: true,
  }], 2)

  isSubmittedRegisterForm = false;
  isUsingExternalIdentityServer = false;
  externalAuthorizationProvider = '';

  currentTabView = 0;

  @ViewChild('registerForm') registerForm: XnFormComponent | undefined;
  @Input('application') application: SaveDraftApplicationRQ | undefined | null;
  @Output('onClose') onClose = new EventEmitter();

  ngOnInit(): void {
    this.isUsingExternalIdentityServer = this.config.isUsingExternalIdentityServer;
    this.externalAuthorizationProvider = this.config.externalAuthorizationProvider;
  }

  ngOnDestroy(): void {
    
  }

  login(){
    
  }

  loginWithIDP(){
    this.auth.loginWithIDP();
  }

  onChangeTabView(change: any){
    this.currentTabView = change.index;
  }

  register(registerForm: XnFormComponent){
    if(!registerForm) return;
    if(!registerForm.isValid()){
      return;
    }
    const data = registerForm.getData() as RegisterFormData;
    const body: RegisterRQ = {
      profile: {
        emailAddress: data.email,
        phoneNumber: data.phoneNumber,
        phoneExt: data.phoneNumberDialCode,
        password: data.password,
        firstName: data.firstName,
        lastName: data.lastName,
        // logonName: data.logonName,
        logonName: data.email,
      }
    };

    if(this.application){
      this.application.utmInfo = this.bookingService.getUtmContent('register') || undefined;
      body.application = this.application;
    }

    this.auth.register(body).subscribe({
      next: (res) => {
        if(res.success){
          this.bookingService.saveSendUtmLocal('register');
          this.googleEventTrigger('register_success', this.loginAction === 'Sitetour' ? 'BookSiteTour' : 'BookBooking')

          let propertyCode = '';

          if(this.application){
            propertyCode = this.application.propertyCode;
          }

          if(propertyCode){
            this.bookingService.readHotelContactInformation(propertyCode).subscribe(contact => {
              this.showSuccessMsg(contact);
            });
          }
          else{
            this.showSuccessMsg();
          }
        }
      }
    })
  }

  showSuccessMsg(contact?: ApiReadHotelContactInformationRS){
    let params: any = {};
    if(contact){
      if(contact.emailAddress){
        params.email = contact.emailAddress;
      }
      if(contact.phoneNumber){
        params.phoneDisplay = `${/^\s*\+/.test(contact.phoneNumber) ? '' : `${contact.phoneNumberExt}`}${contact.phoneNumber}`;
        params.phone = params.phoneDisplay.replace(/[\(\)\s]/ig, '');
      }
    }
    this.translate.get(this.loginAction === 'Sitetour' ? 'msg.register-account-for-sitetour-success' : 'msg.register-account-success', params).subscribe((text) => {
      this.confirmationService.confirm({
        message: text,
        header: 'Message',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'OK',
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        accept: () => {
          this.onClose.emit();
        },
        rejectVisible: false
      });
    })
  }

  validateUserName(value: string){
    const regex = /^[a-zA-Z0-9]+$/;
    return regex.test(value);
  }

  onCloseDialog(){
    this.isRegisterActive = false;
    this.onClose.emit();
  }

  onVisibleChange(visible: boolean) {
    this.visible = visible;
    !visible && this.onClose.emit();
  }

  isRegisterActive = false;

  activateLogin() {
    this.isRegisterActive = false;
  }

  activateRegister() {
    this.isRegisterActive = true;
    this.googleEventTrigger('register_form', this.loginAction == 'Sitetour' ? 'BookSiteTour' : 'BookBooking');
  }

  googleEventTrigger(event: GgEventName, action: GgEventAction) {
    ((window as any).dataLayer || []).push({
      'event': event,
      'action': action,
    });
  }
}
